import React from 'react'
import { TextInput } from '@common/ui'
import { com } from '@eidu/web'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.entity.field.Field

export type EntityFormTextDisplayProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
}

const EntityFormTextDisplay = ({ field, fieldValue }: EntityFormTextDisplayProps) => {
  const loading = fieldValue === undefined
  return (
    <TextInput
      disabled
      required={field.required}
      label={field.name}
      value={fieldValue?.value ?? ''}
      placeholder={loading ? ' ' : undefined}
    />
  )
}

export default EntityFormTextDisplay
